import type { E2eNewsFixture } from './environment.interface';

/** Harmless fixed content; browser-controlled text/HTML must never be accepted by this hook. */
export const e2eNewsFixture: E2eNewsFixture = {
    id: 'e2e-configured-news',
    bannerText: 'E2E configured news message',
    dialogTitle: 'E2E news details',
    dialogContent: 'This fixed message verifies the configured news lifecycle.',
    actionText: 'View test details',
};
